import { useCalendarIntegrationEnabled } from '@/features/integrations/api/use-calendar-integration-enabled';

/** Online services use the Calendar Integration rollout and saved Google connection. */
export function useVirtualMeetingsEnabled(): boolean {
  return useCalendarIntegrationEnabled();
}
